import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || '').trim().replace(/\}$/, '');
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim().replace(/\}$/, '');

let client;
const isProbablyValidUrl = (url) => typeof url === 'string' && (url.startsWith('https://') || url.startsWith('http://'));

const createThrowingClient = (reason) => ({
    from: () => ({
        select: () => Promise.resolve({ data: null, error: new Error(reason) }),
        insert: () => Promise.resolve({ data: null, error: new Error(reason) }),
        update: () => Promise.resolve({ data: null, error: new Error(reason) }),
        delete: () => Promise.resolve({ data: null, error: new Error(reason) }),
        upsert: () => Promise.resolve({ data: null, error: new Error(reason) }),
    }),
    auth: {
        onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => { } } } }),
        getSession: () => Promise.resolve({ data: { session: null }, error: new Error(reason) }),
        signInWithPassword: () => Promise.resolve({ data: { user: null }, error: new Error(reason) }),
        signOut: () => Promise.resolve({ error: new Error(reason) }),
    },
});

try {
    if (!isProbablyValidUrl(supabaseUrl) || !supabaseAnonKey) {
        const reason =
            'Supabase is not configured. Set VITE_SUPABASE_URL (include https://) and VITE_SUPABASE_ANON_KEY in your hosting environment variables, then redeploy.';
        console.error('❌', reason, { supabaseUrlPresent: !!supabaseUrl, supabaseAnonKeyPresent: !!supabaseAnonKey });
        client = createThrowingClient(reason);
    } else {
        // Mixed-content hint: if your site is https but Supabase URL is http, browsers will block requests.
        if (typeof window !== 'undefined' && window.location?.protocol === 'https:' && supabaseUrl.startsWith('http://')) {
            console.error('❌ Supabase URL is http:// while site is https://. This will be blocked by the browser. Use https:// in VITE_SUPABASE_URL.', supabaseUrl);
        }
        client = createClient(supabaseUrl, supabaseAnonKey, {
            auth: {
                persistSession: true,
                autoRefreshToken: true,
                detectSessionInUrl: true,
            },
        });
    }
} catch (e) {
    console.error('❌ Failed to initialize Supabase client:', e);
    client = { from: () => ({}), auth: { getSession: () => Promise.resolve({}) } };
}

export const supabase = client;
